import React, { useState } from 'react';

import {
  InputHeader,
  MenuDesignSectionLabel,
  RemainingCount,
  TextArea,
  TextAreaContainer,
} from './inputs-with-max-length.styles';

type TextAreaWithMaxLengthProps = {
  value: string;
  maxLength: number;
  label: string;
  placeholderText: string;
  width: number;
  testId?: string;
  id?: string;
  onChange: (e: React.ChangeEvent<HTMLTextAreaElement>) => void;
};

export function TextAreaWithMaxLength({
  value,
  maxLength,
  label,
  placeholderText,
  width,
  testId,
  onChange,
  id = 'textarea_with_max_length',
}: TextAreaWithMaxLengthProps): JSX.Element {
  const [charCount, setCharCount] = useState(value.length || 0);

  function setValue(e: React.ChangeEvent<HTMLTextAreaElement>): void {
    onChange(e);
    setCharCount(e.target.value.length);
  }

  return (
    <TextAreaContainer width={width}>
      <InputHeader>
        {label && <MenuDesignSectionLabel htmlFor='textarea_with_max_length'>{label}</MenuDesignSectionLabel>}
        <RemainingCount>
          {charCount}/{maxLength}
        </RemainingCount>
      </InputHeader>
      <TextArea
        value={value}
        maxLength={maxLength}
        placeholder={placeholderText}
        onChange={(e: React.ChangeEvent<HTMLTextAreaElement>) => setValue(e)}
        id={id}
        data-testid={testId}
      />
    </TextAreaContainer>
  );
}
